export default __webpack_public_path__ + "static/media/img6.6ac4c145.jpg";